import {
  GET_BULK_BALANCE_ALERT,
  GET_BULK_BALANCE_ALERT_SUCCESS,
  GET_BULK_BALANCE_ALERT_FAILURE,
  GET_ALERT_BALANCE,
  GET_ALERT_BALANCE_SUCCESS,
  GET_ALERT_BALANCE_FAILURE,
  GET_BULK_PROJECTION_ALERT,
  GET_BULK_PROJECTION_ALERT_SUCCESS,
  GET_BULK_PROJECTION_ALERT_FAILURE,
  GET_PROJECTION_BALANCE_ALERT,
  GET_PROJECTION_BALANCE_ALERT_SUCCESS,
  GET_PROJECTION_BALANCE_ALERT_FAILURE,
} from '../../constants/actionTypes';
import {
  BULK_BALANCE_ALERTS_ENDPOINT,
  BALANCE_ENDPOINT,
  BULK_PROJECTION_ALERT_ENDPOINT,
  PROJECTION_BALANCE_ALERT_ENDPOINT,
} from '../../constants/urls';
import { RSAA } from 'redux-api-middleware';
import { X_BPI_VERSION_0_8_0, X_BPI_VERSION_1_0_0 } from '../../constants/VersionConstants';

export const getBulkBalanceAlerts = () => ({
  [RSAA]: {
    endpoint: BULK_BALANCE_ALERTS_ENDPOINT,
    method: 'GET',
    headers: {
      'x-bpi-version': X_BPI_VERSION_0_8_0,
    },
    types: [GET_BULK_BALANCE_ALERT, GET_BULK_BALANCE_ALERT_SUCCESS, GET_BULK_BALANCE_ALERT_FAILURE],
  },
});

export const getBalanceAlert = (reqBody, accountId) => ({
  [RSAA]: {
    endpoint: BALANCE_ENDPOINT.replace('accountId', accountId),
    method: 'PUT',
    headers: {
      'x-bpi-version': X_BPI_VERSION_0_8_0,
    },
    body: JSON.stringify(reqBody),
    types: [
      { type: GET_ALERT_BALANCE },
      { type: GET_ALERT_BALANCE_SUCCESS },
      {
        type: GET_ALERT_BALANCE_FAILURE,
        meta: reqBody,
      },
    ],
  },
});
export const getBulkProjectionAlert = () => ({
  [RSAA]: {
    endpoint: BULK_PROJECTION_ALERT_ENDPOINT,
    method: 'GET',
    headers: {
      'x-bpi-version': X_BPI_VERSION_1_0_0,
    },
    types: [
      GET_BULK_PROJECTION_ALERT,
      GET_BULK_PROJECTION_ALERT_SUCCESS,
      GET_BULK_PROJECTION_ALERT_FAILURE,
    ],
  },
});
export const getProjectionAlertBalance = (reqBody, accountId) => ({
  [RSAA]: {
    endpoint: PROJECTION_BALANCE_ALERT_ENDPOINT.replace('accountId', accountId),
    method: 'PUT',
    headers: {
      'x-bpi-version': X_BPI_VERSION_1_0_0,
    },
    body: JSON.stringify(reqBody),
    types: [
      { type: GET_PROJECTION_BALANCE_ALERT },
      { type: GET_PROJECTION_BALANCE_ALERT_SUCCESS },
      {
        type: GET_PROJECTION_BALANCE_ALERT_FAILURE,
        meta: reqBody,
      },
    ],
  },
});
